import { ModelTimestamp } from "@doitintl/models-any";

import { type KnownIssue, KnownIssuePlatform, KnownIssueStatus } from "../types";

export const sampleKnownIssue: Partial<KnownIssue> = {
  platform: KnownIssuePlatform.AWS,
  dateTime: ModelTimestamp.now(),
  status: KnownIssueStatus.Ongoing,
};
